export enum WidgetDisplayMode{
    Stack = 'stack',
    Carousel = 'carousel'  
}